const money = (n) => `$${Number(n || 0).toFixed(2)}`;

export function slotWhen(slot) {
  const [y, m, d] = slot.date.split('-').map(Number);
  const day = new Date(y, m - 1, d).toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  const named = slot.label && slot.label !== slot.range;
  return `${day} · ${slot.range}${named ? ` · ${slot.label}` : ''}`;
}

const TIER_NAMES = { standard: 'New', silver: 'Silver', gold: 'Gold', platinum: 'Platinum', onyx: 'Onyx', black_card: 'Black Card' };

// Indented fee breakdown under "Delivery" (custom fee names; $0 fees omitted).
export function FeeLines({ lines, waived, tier, modern, testId = 'fee-lines' }) {
  if (!lines?.length) return null;
  const row = modern ? { display: 'flex', justifyContent: 'space-between', fontSize: 12.5, color: 'var(--am-ink-3)', paddingLeft: 12 } : undefined;
  return (
    <div className={modern ? '' : 'space-y-0.5'} style={modern ? { display: 'flex', flexDirection: 'column', gap: 2 } : undefined} data-testid={testId}>
      {lines.map((l) => (
        <div key={l.key} className={modern ? '' : 'flex justify-between font-mono text-xs text-[#6B8E73] pl-3'} style={row} data-testid={`${testId}-${l.key}`}>
          <span>{l.label}</span><span className={modern ? 'am-tnum' : ''}>{Number(l.amount) > 0 ? money(l.amount) : 'Free'}</span>
        </div>
      ))}
      {waived && (
        <p className={modern ? '' : 'font-mono text-[11px] text-[#FF9F0A] pl-3'} style={modern ? { fontSize: 12, color: 'var(--am-emerald-700)', paddingLeft: 12 } : undefined} data-testid={`${testId}-waived`}>
          {TIER_NAMES[tier] ? `${TIER_NAMES[tier]} discount applied` : 'Tier discount applied'}
        </p>
      )}
    </div>
  );
}

// Items / points / delivery rows above the total — only for slotted orders.
export function OrderFeeRows({ order, modern }) {
  if (!order?.delivery_slot) return null;
  const fee = Number(order.delivery_fee || 0);
  const rows = [
    ['Items', money(order.subtotal), 'order-breakdown-items'],
    ...(Number(order.discount) > 0 ? [[`Points discount (${order.redeemed_pts} pts)`, `−${money(order.discount)}`, 'order-breakdown-discount']] : []),
    ['Delivery fee', fee > 0 ? money(fee) : 'Free', 'order-breakdown-delivery'],
  ];
  return (
    <div className={modern ? '' : 'pt-3 space-y-1.5'} style={modern ? { paddingTop: 12, display: 'flex', flexDirection: 'column', gap: 6 } : undefined} data-testid="order-fee-breakdown">
      {rows.map(([label, value, tid]) => (
        <div key={tid} className={modern ? '' : 'flex justify-between font-mono text-sm text-[#A3C7A8]'}
             style={modern ? { display: 'flex', justifyContent: 'space-between', fontSize: 14, color: 'var(--am-ink-2)' } : undefined}>
          <span>{label}</span>
          <span className={modern ? 'am-tnum' : ''} style={modern ? { color: 'var(--am-ink-1)', fontWeight: 500 } : undefined} data-testid={tid}>{value}</span>
        </div>
      ))}
      <FeeLines lines={order.delivery_slot.fee_lines} waived={order.delivery_slot.fee_waived} tier={order.delivery_slot.fee_tier} modern={modern} testId="order-fee-lines" />
    </div>
  );
}
